import { render, staticRenderFns } from "./partialRemittance.vue?vue&type=template&id=77184f20&scoped=true&"
import script from "./partialRemittance.vue?vue&type=script&lang=js&"
export * from "./partialRemittance.vue?vue&type=script&lang=js&"
import style0 from "./partialRemittance.vue?vue&type=style&index=0&id=77184f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77184f20",
  null
  
)

export default component.exports